export default __webpack_public_path__ + "static/12-4bcbe9b990586d3b4e02d503ad80fd9c.jpg";